import { FlightDesignator } from '@models/booking.models';
import { N0AvailableJourney } from '@models/responses/availability-response.model';

export const validateFlightDates = (
  selectedJourneys: (N0AvailableJourney | null)[],
): boolean => {
  const nonNullJourneys = selectedJourneys.filter(
    (j): j is N0AvailableJourney => j !== null,
  );
  // if any journey is between another journey, fail (return false)
  // otherwise true.
  const doAnyFlightsOverlap = nonNullJourneys.some((j) => {
    // check if this journey is in the middle of any other journey
    // i.e. departure is between departure and arrival, or arrival
    // is between departure and arrival of another flight
    return nonNullJourneys
      .filter((j2) => j2 !== j)
      .some((j2) => {
        return (
          (j.designator.departure >= j2.designator.departure &&
            j.designator.departure <= j2.designator.arrival) ||
          (j.designator.arrival >= j2.designator.departure &&
            j.designator.arrival <= j2.designator.arrival)
        );
      });
  });

  const areFlightsInOrder = nonNullJourneys.reduce(
    (runningResult, journey, journeyIndex) => {
      const nextJourney = nonNullJourneys[journeyIndex + 1];
      return (
        runningResult &&
        (!nextJourney ||
          journey.designator.departure < nextJourney.designator.departure)
      );
    },
    true,
  );

  return areFlightsInOrder && !doAnyFlightsOverlap;
};

export const getCityPairFromDesignator = (designator?: FlightDesignator) => {
  if (!designator) {
    return '';
  }
  return `${designator.origin} - ${designator.destination}`;
};

const sellingOutBadgeTriggers: string[] = ['M', 'K3', 'K2', 'K', 'H3', 'H2', 'H', 'B3', 'B2', 'B', 'Y3', 'Y2', 'Y']
export const isTheFlightSellingOut = (fareClass: string | undefined):boolean => {
  if (!fareClass) {
    return false;
  }
  return sellingOutBadgeTriggers.includes(fareClass);
}
